var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "title" }, [_vm._v("\n    Claim Airdrop\n  ")]),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c("mmLogin", { on: { success: _vm.getAccount } }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "des" }, [
      _vm._v("First, "),
      _c("span", [_vm._v("connect your wallet")]),
      _vm._v(". And check for UNIT Airdrop eligibility"),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }